import React, { useContext } from "react";

import { AudioState, Preview } from "@creatomate/preview";
import { MillisecondsField } from "@culturehq/components";
import { MillisecondsFieldValue } from "@culturehq/components/dist/components/form/MillisecondsField";

import { ElementSource } from "chq";
import { Trans } from "app/utils";
import { VIDEO_TYPE } from "../../utils/constants";
import { CreatomateContext } from "../../contexts/VideoStudioContext";
import { isSubtitleText, trimSubtitles } from "../../sidebar/tabs/subtitle/utils";
import { isStoryElement } from "../../utils";

interface TrimStartProps {
  activeElement: AudioState;
  preview: Preview;
}

const TrimStart: React.FC <TrimStartProps> = ({ activeElement, preview }) => {
  const { handleUpdateData } = useContext(CreatomateContext);
  const elementType = activeElement.source.type;

  const handleTrimStartChange = async (value: MillisecondsFieldValue) => {
    const trimStart = (value || 0) / 100;
    if (trimStart > activeElement.duration) return;

    const newElements: ElementSource[] = [];
    const source = preview.getSource();

    const noSubtitlesElements = source.elements.filter((element: ElementSource) => (
      !isSubtitleText(element.name)
    ));
    newElements.push(...noSubtitlesElements);
    const allSubtitles = source.elements.filter((element: ElementSource) => (
      isSubtitleText(element.name)
    ));

    if (elementType === VIDEO_TYPE && allSubtitles.length === 0) {
      handleUpdateData({ blockSubtitles: true });
    }

    if (elementType === VIDEO_TYPE && isStoryElement(activeElement.source)) {
      if (allSubtitles.length > 0) {
        const trimmedSubtitles = trimSubtitles(
          allSubtitles,
          {
            time: trimStart - (activeElement.source.trim_start || 0),
            duration: activeElement.duration
          },
          activeElement.source.id,
          true
        );
        newElements.push(...trimmedSubtitles);
      }
    }

    await preview.setSource({
      ...source,
      elements: newElements.map((element: ElementSource) => {
        if (element.id !== activeElement.source.id) return element;

        return {
          ...element,
          trim_start: trimStart,
          duration: activeElement.duration - trimStart
        };
      })
    }, true);
  };

  return (
    <MillisecondsField
      className="chq-ffd-border"
      min={0}
      name="trim_start"
      onChange={handleTrimStartChange}
      value={
        activeElement?.source?.trim_start === undefined
          ? 0 : activeElement?.source?.trim_start * 100
      }
    >
      <Trans>Trim Start {elementType === "audio" ? "Audio" : "Video"}</Trans>
    </MillisecondsField>
  );
};

export default TrimStart;
